var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ed25519-hd-key'),
    derivePath = _require.derivePath,
    isValidPath = _require.isValidPath,
    getMasterKeyFromSeed = _require.getMasterKeyFromSeed;

var nacl = require("tweetnacl");

nacl.util = require("tweetnacl-util");

var sjcl = require("sjcl");

var typeConverter = require("./typeConverter");

var masterKeySeed = require("./masterKeySeed");

var _require2 = require("./config"),
    oltAddrPrefix = _require2.oltAddrPrefix;

var util = require("./util");

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
/* *****************************   Ed25519 For Oneledger  ***************************** */
// derive 32 bytes masterKey from masterKeySeed
// input : masterKeySeed is a 64 bytes hex string
// return : masterKey which is a 32 bytes Uint8Array

function deriveMasterKey(masterKeySeed) {
  var _getMasterKeyFromSeed = getMasterKeyFromSeed(masterKeySeed),
      key = _getMasterKeyFromSeed.key,
      chainCode = _getMasterKeyFromSeed.chainCode;

  return typeConverter.bufferToUint8Array(key);
} // derive new privateKeySeed based on masterKey and keyPath
// input : masterKey should be a 32 bytes uint8array for Ed25519, masterKey should be the derived key part of masterKey
// input : keyPath is a string
// return : derived new privateKeySeed which is a 32 byte buffer


function derivePrivateKeySeed(masterKey, keyPath) {
  var hexMasterKey = typeConverter.uint8arrayToHexStr(masterKey);

  var _derivePath = derivePath(keyPath, hexMasterKey),
      key = _derivePath.key,
      chainCode = _derivePath.chainCode;

  return key;
} // derive new keyPair from privateKeySeed
// input : privateKeySeed should be a 32 bytes buffer for Ed25519, privateKeySeed should be derived key part of privateKeySeed
// return : derived keyPair which the private key is a 64 byte based64 string and public Key is a 32 bytes base64 string


function deriveKeyPair(privateKeySeed) {
  var _nacl$sign$keyPair$fr = nacl.sign.keyPair.fromSeed(privateKeySeed),
      publicKey = _nacl$sign$keyPair$fr.publicKey,
      secretKey = _nacl$sign$keyPair$fr.secretKey;

  return {
    publicKey: nacl.util.encodeBase64(publicKey),
    privateKey: nacl.util.encodeBase64(secretKey)
  };
} // derive the address of the new keyPair
// input : publicKey should be a 32 bytes base64 string
// return : address from public key based on SHA256, return 0lt prefix and first 40 chars length address


function deriveAddress(publicKey) {
  var base64PublicKey = sjcl.codec.base64.toBits(publicKey);
  var hash = new sjcl.hash.sha256();
  hash.update(base64PublicKey);
  var hashResult = hash.finalize();
  var hashedData = sjcl.codec.hex.fromBits(hashResult);
  hash.reset();
  return "".concat(oltAddrPrefix).concat(hashedData.substring(0, 40));
} // verify OLT address


function verifyAddress(address) {
  return util.isValidOLTAddress(address);
} // sign OLT tx
// input : message should be a base64 string
// input : password is plaintext
// input : encryptedMasterKeySeed is a string
// input : keyPath is a string
// return : promise containing error object or base64 signature


function signForSignature(_x) {
  return _signForSignature.apply(this, arguments);
} // verify OLT tx signature
// input : message, signature and publicKey are all base64 string
// return : promise containing error object or verifyResult (true || false)


function _signForSignature() {
  _signForSignature = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var message, password, encryptedMasterKeySeed, keyPath, decryptedMasterKeySeed, masterKey, derivedPrivateKeySeed, _deriveKeyPair, privateKey, publicKey, signature;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            message = _ref.message, password = _ref.password, encryptedMasterKeySeed = _ref.encryptedMasterKeySeed, keyPath = _ref.keyPath;
            _context.next = 3;
            return masterKeySeed.masterKeySeedDecryption(password, encryptedMasterKeySeed).catch(function (error) {
              return Promise.reject(error);
            });

          case 3:
            decryptedMasterKeySeed = _context.sent;
            masterKey = deriveMasterKey(decryptedMasterKeySeed);
            derivedPrivateKeySeed = derivePrivateKeySeed(masterKey, keyPath);
            _deriveKeyPair = deriveKeyPair(derivedPrivateKeySeed), privateKey = _deriveKeyPair.privateKey, publicKey = _deriveKeyPair.publicKey;
            signature = nacl.util.encodeBase64(nacl.sign.detached(Uint8Array.from(nacl.util.decodeBase64(message)), nacl.util.decodeBase64(privateKey)));
            masterKey = null;
            derivedPrivateKeySeed = null;
            return _context.abrupt("return", Promise.resolve(signature));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _signForSignature.apply(this, arguments);
}

function verifySignature(message, signature, publicKey) {
  return new Promise(function (resolve, reject) {
    var verifyResult;

    try {
      verifyResult = nacl.sign.detached.verify(Uint8Array.from(nacl.util.decodeBase64(message)), nacl.util.decodeBase64(signature), nacl.util.decodeBase64(publicKey));
    } catch (err) {
      reject(ErrorUtil.errorWrap(requestErrors.InvalidOLTSignature));
    }

    resolve(verifyResult);
  });
}

module.exports = {
  deriveMasterKey: deriveMasterKey,
  derivePrivateKeySeed: derivePrivateKeySeed,
  deriveKeyPair: deriveKeyPair,
  deriveAddress: deriveAddress,
  verifyAddress: verifyAddress,
  signForSignature: signForSignature,
  verifySignature: verifySignature
};